import React from 'react';
import './SelectState.scss';
import selectStatesArrow from '../../assets/select-states-arrow.svg';

function SelectStateButton({ handleClickSelectState, selectStateButtonRef, showStates, loc }) {
  return (
    <button
      ref={loc === 'top' ? selectStateButtonRef : null}
      className={loc === 'top' ? 'select mobile-only' : 'select areaDetailMobile__select'}
      onClick={
        showStates
          ? () => {
              handleClickSelectState('close');
            }
          : () => {
              handleClickSelectState('open');
            }
      }
    >
      select a state
      <img
        src={selectStatesArrow}
        alt={loc === 'top' ? 'down arrow' : 'up arrow'}
        className={loc === 'top' ? 'select__arrow' : 'select__arrow select__arrow--nav'}
      />
    </button>
  );
}

export default SelectStateButton;
